import React from 'react';
import SnackbarContent from '@mui/material/SnackbarContent';
import Snackbar from '@mui/material/Snackbar';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { useMessaging, Options, CallbackFunction } from 'providers/messaging';
import { useApp } from 'providers/app';

const useStyles = makeStyles({
  message: {
    marginLeft: 10,
    paddingTop: 3,
  },
  messageContent: {
    display: 'flex',
  },
  snackbar: {
    bottom: 10,
  },
});

interface MessagingProps {
  message: string;
  options: Options | null;
  action: CallbackFunction | null;
  handleAction(): void;
  open: boolean;
}

const Messaging: React.FC<MessagingProps> = ({ message, options, action, handleAction, open }) => {
  const classes = useStyles();
  const app = useApp();
  const messaging = useMessaging();

  return (
    <Snackbar
      style={options || undefined}
      classes={{
        anchorOriginBottomCenter: !app.isMobile ? classes.snackbar : undefined,
      }}
      open={open}
      onClose={messaging.handleClose}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: app.isMobile ? 'left' : 'center',
      }}
    >
      <SnackbarContent
        message={
          <div className={classes.messageContent}>
            <span className={classes.message}>{message}</span>
          </div>
        }
        action={
          action ? (
            <Button key="undo" color="primary" size="small" onClick={handleAction}>
              Desfazer
            </Button>
          ) : (
            <Button size="small" color="primary" onClick={messaging.handleClose}>
              Fechar
            </Button>
          )
        }
      />
    </Snackbar>
  );
};

export default Messaging;
